import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import {
  CountryList as UIFoundationsCountryList,
  Container,
  ContainerDisplays
} from '@dcxwam/dcx-wam-ui-foundations'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../../functional/ErrorBoundary'
import {
  WithAutomaticTestIdsType,
  withAutomaticTestIds
} from '../../../../utils/aem/with-automatic-test-ids'
import { EditableComponentPropsType } from '../../../../utils/prop-types'
import CountryListEditConfig from './CountryListEditConfig'
import { CountryListModelProps } from './types'

const CountryList = withComponentRefresh(
  withAutomaticTestIds(
    (
      props: WithAutomaticTestIdsType<
        EditableComponentPropsType<CountryListModelProps>
      >
    ) => {
      const {
        regions,
        hideCountryList,
        flagAltTextSuffix,
        collapseAriaLabel,
        expandAriaLabel
      } = props.model
      const isAuthor = AuthoringUtils.isInEditor()

      // If no region groups data, show placeholder in edit mode
      if (isAuthor && CountryListEditConfig.isEmpty(props.model)) {
        return (
          <EditableComponent {...props}>
            {CountryListEditConfig.emptyLabel}
          </EditableComponent>
        )
      }

      const uiCountryListProps = {
        regions,
        separator: '|',
        flagAltTextSuffix,
        collapseAriaLabel,
        expandAriaLabel
      }

      return (
        <EditableComponent {...props}>
          <Container
            {...(hideCountryList && { display: ContainerDisplays.None })}
          >
            <UIFoundationsCountryList {...uiCountryListProps} />
          </Container>
        </EditableComponent>
      )
    }
  )
)

const CountryListWithErrorBoundary = withErrorBoundary(CountryList, {
  componentName: 'CountryList',
  fallback: <ErrorFallback componentName="CountryList" />
})

export default CountryListWithErrorBoundary
